import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-how-to-use-apis',
  templateUrl: './how-to-use-apis.component.html',
  styleUrls: ['./how-to-use-apis.component.scss']
})
export class HowToUseApisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  onMarkdownError(event) {
    console.error('MARKDOWN', event);
  }

}
